import { GaugingElement } from '../InspectionElements/gaugingElement'
import { WorkableElement } from '../WorkableElement'
import type { Mesh, Material } from '@phdsoft/three';

export class BasicElement extends WorkableElement {

  insertionMethod: string
  elementNameId: string
  elementCategory: string
  targetElements: string[]
  createdAt: Date
  Label: string
  ActionId: string

  public VerifyProperties() {
    throw new Error('Method not implemented.')
  }

  private _elementProperties: any

  public get elementProperties(): any {
    return this._elementProperties
  }

  public set elementProperties(value: any) {
    this._elementProperties = value
  }

  private _target: WorkableElement
  public get target(): WorkableElement {
    return this._target
  }

  public set target(v: WorkableElement) {
    this._target = v
  }

  constructor(
    id: string,
    mesh: Mesh,
    material: Material,
    regionId: string,
    sectionId: string,
    elementNameId: string,
    elementCategory: string,
    insertionMethod: string,
    Label: string,
    actionId: string,
  ) {
    super(mesh, material, id)
    this.Guid = id
    this.regionId = regionId
    this.SectionId = sectionId
    this.elementNameId = elementNameId
    this.elementCategory = elementCategory
    this.insertionMethod = insertionMethod
    this.Label = Label
    this.ActionId = actionId
    // this.targetElements = targetElements
  }
}
